<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-content-article-author-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Author
            </h4>
          </div>

          <div class="modal-body">
            <RadioFormGroup
                v-model="data.type"
                name="type"
                label="Type"
                :error="(errors.type || [])[0]"
                :options="[{value: 'users', label: 'User'}, {value: 'people', label: 'Person'}]"
            />

            <TypeaheadFormGroup
                key="users"
                v-if="data.type === 'users'"
                v-model="data.id"
                name="id"
                label="User"
                :error="(errors.id || [])[0]"
                endpoint="/api/v2/users"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.full_name"
            />

            <TypeaheadFormGroup
                key="people"
                v-if="data.type === 'people'"
                v-model="data.id"
                name="id"
                label="Person"
                :error="(errors.id || [])[0]"
                endpoint="/api/v2/people"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="getPersonLabel"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {RadioFormGroup, TypeaheadFormGroup},


  props: {
    contentArticle: {
      required: true
    }
  },

  data() {
    return {
      data: {
        type: 'users'
      },

      shared: store,

      errors: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    'data.type'() {
      this.data.id = null
    }
  },

  computed: {
    type() {
      return this.data.type
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/content-articles/' + this.contentArticle.id + '/author', this.data)
          .then(response => {
            notify.success('The author was updated')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            if (error.response.status === 422) {
              return this.errors = error.response.data.errors
            }

            throw error
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    },

    getPersonLabel(person) {
      if (person.attributes.company_id) {
        return person.attributes.name + ' (' + person.attributes.company_name + ')'
      }

      return person.attributes.name
    }
  }
}
</script>
